import { render, staticRenderFns } from "./DeviceAvatar.vue?vue&type=template&id=752b10a8&scoped=true&"
import script from "./DeviceAvatar.vue?vue&type=script&lang=js&"
export * from "./DeviceAvatar.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAvatar.vue?vue&type=style&index=0&id=752b10a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b10a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752b10a8')) {
      api.createRecord('752b10a8', component.options)
    } else {
      api.reload('752b10a8', component.options)
    }
    module.hot.accept("./DeviceAvatar.vue?vue&type=template&id=752b10a8&scoped=true&", function () {
      api.rerender('752b10a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/DeviceAvatar.vue"
export default component.exports